<template>
    <div class="c-row">
        <div class="c-tr">
            <div class="c-td is-1">
                <p
                    v-text="location.full_name"
                    class="text-md font-weight-medium mb-1"
                />
                <p v-text="location.fullAddress" class="text-xs mb-0" />
            </div>
            <div class="c-td is-2">
                <span v-text="'Wybrany pakiet'" class="typo-label" />
                {{ tariff }}
            </div>
            <div class="c-td is-3">
                <span v-text="'Status subskrypcji'" class="typo-label" />
                <span
                    v-tooltip="status.tooltip"
                    class="status"
                    :class="status.class"
                >
                    <span v-text="status.text" />
                    <a-icon v-if="status.tooltip" icon="Info" />
                </span>
            </div>
            <div class="c-td is-4">
                <span v-text="'Zintegrowane urządzenia'" class="typo-label" />
                <div
                    v-for="(dev, idx) of location.deviceSummary"
                    :key="idx"
                    class="d-flex justify-content-between mb-2"
                >
                    <div class="d-flex align-items-center">
                        <img
                            class="mr-2"
                            width="18"
                            :src="require(`@/assets/img/drs/${dev.img}`)"
                        />

                        <span v-text="dev.label" />
                    </div>
                    <span v-text="dev.count" />
                </div>
            </div>
            <div class="c-td is-5">
                <the-btn
                    v-if="canConfigure"
                    class="btn-primary btn-sm w-100"
                    text="Konfiguruj pakiet"
                    @click="createSubscription"
                />
                <the-btn
                    v-else
                    v-tooltip="cancelSubscriptionTooltip"
                    class="btn-danger btn-sm w-100"
                    text="Anuluj subskrypcję"
                    :disabled="!canCancelSubscription"
                    @click="cancelSubscription"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'

export default {
    cancelDisabledTooltip: 'Jeśli chcesz anulować subskrypcję, skontaktuj się z <strong>pomoc@kaucyjni.pl</strong>',

    props: {
        location: { type: Object, required: true }
    },

    computed: {
        ...mapGetters('drs', ['getAllSubscriptionsByLocationId', 'cancelableShops']),

        locSubscriptions() {
            return this.getAllSubscriptionsByLocationId(this.location.id)
        },

        subscription() {
            return this.locSubscriptions.current || this.locSubscriptions.expiring
        },

        isTariff() {
            return !!this.subscription?.tariff_name
        },

        canConfigure() {
            if (this.isTariff && this.locSubscriptions.current) {
                // If there's an active subscription, show only Abort button
                return false
            }

            if (this.isTariff && this.locSubscriptions.expiring?.date_to) {
                // Allow configuring new subscription if current one is expiring and not yet expired
                const today = moment()
                const subscriptionEndDate = moment(this.subscription.date_to)

                return today.isBefore(subscriptionEndDate)
            }

            // If there's no active subscription, show Configure button
            return !this.isTariff
        },

        isSubscriptionCanceled() {
            return !this.locSubscriptions.current && !!this.locSubscriptions.expiring
        },

        canCancelSubscription() {
            return this.cancelableShops.some(shop => shop.id === this.location.id)
        },

        cancelSubscriptionTooltip() {
            return !this.isSubscriptionCanceled && !this.canCancelSubscription
                ? this.$options.cancelDisabledTooltip
                : null
        },

        tariff() {
            return this.isTariff ? this.subscription.tariff_name : '---'
        },

        status() {
            if (this.isSubscriptionCanceled) {
                return {
                    class: 'is-warning',
                    text: 'Anulowana',
                    tooltip: `Subskrypcja została anulowana. Funkcjonalność systemu kaucyjnego pozostaje
                        aktywna do <strong>${moment(this.locSubscriptions.expiring.date_to).format('DD-MM-YYYY')}</strong>`
                }
            }

            return this.isTariff
                ? {
                    class: 'is-success',
                    text: 'Aktywna'
                }
                : {
                    class: 'is-incompatible',
                    text: 'Nieaktywna'
                }
        }
    },

    methods: {
        ...mapActions('drsTariffs', ['setConfigMode']),

        cancelSubscription() {
            this.$store.dispatch('openModal', {
                componentPath: 'drs/payment/CancelConfirm',
                args: {
                    selectedShops: [this.location.id]
                }
            })
        },

        async createSubscription() {
            await this.setConfigMode('create')
            this.$store.dispatch('openModal', {
                componentPath: 'drs/configuration/SelectTariff'
            })
        }
    }
}
</script>